<template>
    <header class="hero">
        <BlurredBackground
            :image="background"/>
        
        <div class="coverWrapper">
            <img class="cover"
                :src="cover"
                alt="Creatillo blog cover image"/>

            <div class="content">
                <Heading
                    size="xxl">
                    {{ heading }}
                </Heading>
                <Heading v-if="subheading"
                    :h="2"
                    size="m">
                    {{ subheading }}
                </Heading>

                <div class="buttons"
                    v-if="buttons">
                    <Button class="upload"
                        v-if="permission"
                        appearance="cta"
                        size="small"
                        prefixIcon="add_circle"
                        @click="$emit('primary')">
                        {{ secondaryLabel }}
                    </Button>
                    <Button class="drafts"
                        v-if="permission && routerLink"
                        appearance="secondary"
                        size="small"
                        prefixIcon="edit"
                        :url="routerLink">
                        {{ primaryLabel }}
                    </Button>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    export default {
        name: 'Hero',
        props: {
            background: {
                type: String,
                required: true
            },
            routerLink: {
                type: String
            },
            buttons: {
                type: Boolean,
                default: true
            },
            primaryLabel: {
                type: String
            },
            secondaryLabel: {
                type: String
            },
            cover: {
                type: String,
                required: true
            },
            heading: {
                type: String,
                required: true
            },
            subheading: {
                type: String
            },
            permission: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../scss/variables';

    .hero {
        position: relative;
    }

    .coverWrapper {
        position: relative;
        padding: 3rem 4rem 5rem 4rem;
        min-height: 20rem;
        width: 100%;
        border-radius: 0.75rem;
        overflow: hidden;
    }

    .cover {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        z-index: 1;
        background: var(--color-grey-150);
    }

    .content {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        z-index: 1;
    }

    .h1 {
        margin: 0 0 1.5rem 0;
        color: var(--color-white-important);
    }

    .h2 {
        max-width: 28rem;
        margin: 0;
        color: var(--color-white-important);
    }

    .buttons {
        display: flex;
        margin-top: 1.5rem;
    }

    .upload {
        z-index: 1;
        margin-right: 1rem;
    }

    @media all and (max-width: 640px) {
        .coverWrapper {
            min-height: 16rem;
            padding: 2rem 1rem 3rem 1rem;
        }

        .content {
            align-items: center;
        }

        .h1, h2 {
            text-align: center;
            margin-right: auto;
            margin-left: auto;
        }
    }
</style>